<script setup>
import { useShared } from '../state.js';
import { useToasts } from '../use_toasts.js';

const { computeError } = useShared();
const { toasts } = useToasts();
</script>

<template>
  <div class="popup-stack">
    <div v-if="computeError" class="popup popup-persistent">
      {{ computeError }}
    </div>
    <TransitionGroup name="popup-fade" tag="div" class="popup-toasts">
      <div v-for="t in toasts" :key="t.id" class="popup popup-toast" :class="{ 'popup-toast-success': t.variant === 'success' }">
        {{ t.message }}
      </div>
    </TransitionGroup>
  </div>
</template>

<style scoped>

.popup-stack {
  position: fixed;
  top: var(--space-lg);
  right: var(--space-lg);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: var(--space-sm);
  max-width: min(360px, calc(100vw - 2 * var(--space-lg)));
  pointer-events: none;
}

.popup-toasts {
  display: flex;
  flex-direction: column;
  gap: var(--space-sm);
  position: relative; /* containing block for a leaving toast's position:absolute */
}

.popup {
  padding: var(--space-sm) var(--space-md);
  border-radius: var(--border-radius);
  background: var(--color-danger);
  color: var(--color-text-light);
  box-shadow: var(--shadow-md);
  font-size: var(--font-size-sm);
  word-break: break-word;
  pointer-events: auto;
}

/* e.g. sync.js's "Sync is working again." — a toast confirming a recovery,
   not reporting a problem, so it shouldn't read as an alert like every
   other (red) toast here. */
.popup-toast-success {
  background: var(--color-success);
}

.popup-fade-enter-active,
.popup-fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.popup-fade-enter-from,
.popup-fade-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

.popup-fade-leave-active {
  position: absolute; /* let siblings collapse into the vacated slot smoothly */
}
</style>
